/*==================================================
HERSHOP PRODUCT BLURB
==================================================*/

(function () {
    "use strict";

    function initBlurb() {

        const section = document.querySelector(".hershop-product-blurb");

        if (!section) return;

        const items = section.querySelectorAll(".hershop-product-blurb__item");

        items.forEach((item, index) => {

            item.style.opacity = "0";

            item.style.transform = "translateY(40px)";

            item.style.transition =
                "opacity .7s ease, transform .8s cubic-bezier(.22,.61,.36,1)";

            item.style.transitionDelay = (index * 120) + "ms";

        });

        const observer = new IntersectionObserver(function (entries) {

            entries.forEach(function (entry) {

                if (!entry.isIntersecting) return;

                items.forEach(function (item) {

                    item.style.opacity = "1";

                    item.style.transform = "translateY(0)";

                });

                observer.disconnect();

            });

        }, {
            threshold: 0.2
        });

        observer.observe(section);

    }

    if (document.readyState === "loading") {

        document.addEventListener("DOMContentLoaded", initBlurb);

    } else {

        initBlurb();

    }

    document.addEventListener("shopify:section:load", initBlurb);

})();